import { gql } from "@apollo/client";
import Fragment from "../fragments/fragments";

export const USER_PROFILE_QUERY = gql`
  query userInfo {
    userInfo {
      companyName
      email
      ezcName
      firstName
      isEZC
      isMiddleOffice
      isNotInHierarchy
      lastName
      middleOfficeName
      mobilePhone
      position
      regionalManagerName
      userId
      userAdditionalData {
        ...userAdditionalData
      }
    }
  }
  ${Fragment.userAdditionalData}
`;

export const USER_GROUPS_QUERY = gql`
  query userGroups {
    userGroups {
      isAdmin
      userGroupCode
      userGroupId
      userGroupName
      userId
    }
  }
`;

export const USER_RIGHTS_QUERY = gql`
  query userRights($pager: PagerInput!, $filters: UserRightFilterInput!) {
    userRights(pager: $pager, filters: $filters) {
      total
      values {
      authorizationId
      authorizationName 
      isRefined
      documentTypeStates {
        documentTypeName
        documentStates
      }
    }
  }
}
`;

export const USER_AGENDA_QUERY = gql`
  query userAgenda($userId: Int!) {
    userAgenda(userId: $userId) {
      contactName
      email
      userId
      id
    }
  }
`;